import {Component, Input} from '@angular/core';
import {EmailConfiguration} from "@features/support/components/support-configuration/support-configuration.component";
import {PlatformCommand} from "@shared/commands/command-base";
import {Api} from "@shared/constants/common-field.constants";
import {take} from "rxjs/operators";
import {CommandService} from "@core/services/command.service";

@Component({
    standalone: false,
    selector: 'app-support-email-configuration',
  templateUrl: './support-email-configuration.component.html',
  styleUrl: './support-email-configuration.component.scss'
})
export class SupportEmailConfigurationComponent {
  @Input() emailConfiguration : EmailConfiguration;
  selectedDays: number | null = null;
  dropdownData : {days: number} [] = [];

  constructor(private commandService: CommandService) {
  }

  ngOnInit() {
    console.log(this.emailConfiguration);
    this.selectedDays = this.emailConfiguration?.numberOfDaysToRemindForComments;
    this.dropdownData.push({days: 1}, {days: 2}, {days: 3}, {days: 4}, {days: 5});
  }

  onSave() {
    const saveEmailConfigurationCommand = new PlatformCommand('SaveEmailConfigurationCommand', Api.TaskManager);
    saveEmailConfigurationCommand.fieldValues['NumberOfDaysToRemindForComments'] = this.selectedDays;

    this.commandService.executePlatformCommand(saveEmailConfigurationCommand).pipe(take(1)).subscribe(
      response => {

      });
  }
}
